<image-picker [multiple]="false" [showRemove]="false" [formControl]="formControl"></image-picker>
